export default __webpack_public_path__ + "static/media/1776.d52bd35c.png";